import {i18n} from '@yourcoach/i18n';

import type {EditionApiModel} from '../../../api/program';

import {alert} from '../../../components/alert';
import {isIamCoach} from '../../../utils/entity/isIamCoach';
import {
  isEditionEvergreen,
  parseDuration,
  parsePaymentPlan,
} from '../../../utils/entity/program';
import {logger} from '../../../utils/logger';
import {getPriceString} from '../../../utils/money';
import * as S from './styles';

type Config = {
  edition: EditionApiModel;
};

export function showEditionNewDetailsAlert({edition}: Config) {
  const {parsedCurrency, total} = parsePaymentPlan(edition.payment_plan);

  logger.event('request_cancelled_changes_view');

  return alert.show({
    buttons: [
      {
        hideAlertOnClick: true,
        label: i18n.t('shared:got_it'),
        scheme: isIamCoach() ? 'primary' : 'secondary',
      },
    ],
    renderMessage: () => (
      <S.Container>
        <S.Section>
          <S.Row>
            <S.Label>{i18n.t('shared:price')}</S.Label>
            <S.Value>
              {getPriceString({currency: parsedCurrency, price: total})}
            </S.Value>
          </S.Row>
          <S.Row>
            <S.Label>{i18n.t('shared:duration')}</S.Label>
            <S.Value>
              {isEditionEvergreen(edition)
                ? i18n.t('shared:evergreen')
                : parseDuration(edition.duration).toString()}
            </S.Value>
          </S.Row>
        </S.Section>
        {edition.private_data_request.length ? (
          <>
            <S.Title>{i18n.t('shared:personal_info')}</S.Title>
            <S.Section>
              {edition.private_data_request.map((privateInfoKey: string) => (
                <S.Label key={privateInfoKey}>
                  {
                    /**
                     * @i18n_parser
                     *
                     * t('shared:private_profile.date_of_birth')
                     * t('shared:private_profile.email')
                     * t('shared:private_profile.first_name')
                     * t('shared:private_profile.gender')
                     * t('shared:private_profile.last_name')
                     * t('shared:private_profile.location')
                     * t('shared:private_profile.middle_name')
                     * t('shared:private_profile.phone')
                     */
                    i18n.t(`shared:private_profile.${privateInfoKey}`)
                  }
                </S.Label>
              ))}
            </S.Section>
          </>
        ) : null}
      </S.Container>
    ),
    title: i18n.t('shared:new_details'),
  });
}
